// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__yFa0O","errorLogs":"EditorFooter_errorLogs__1GkwG"};